// src/store/auth.js
import { defineStore } from 'pinia'
import api from '../services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    username: localStorage.getItem('_username') || null,
    role: localStorage.getItem('_role') || null,
    loading: false,
    error: null
  }),
  
  actions: {
    async login(username, password) {
      this.loading = true
      this.error = null
      
      try {
        const response = await api.login({ username, password })
        const { token, role } = response.data
        
        this.token = token
        this.username = username
        this.role = role || 'user'
        
        localStorage.setItem('token', token)
        localStorage.setItem('_username', username)
        localStorage.setItem('_role', this.role)
        
        return true
      } catch (error) {
        this.error = error.response?.data?.message || 'Identifiants incorrects'
        return false
      } finally {
        this.loading = false
      }
    },
    
    logout() {
      this.token = null
      this.username = null
      this.role = null
      
      localStorage.removeItem('token')
      localStorage.removeItem('_username')
      localStorage.removeItem('_role')
    }
  }
})